export default __webpack_public_path__ + "static/media/2023 (1).39b3c9d8.jpg";